import { render, staticRenderFns } from "./com-edit-article.vue?vue&type=template&id=5c582616&"
import script from "./com-edit-article.vue?vue&type=script&lang=js&"
export * from "./com-edit-article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports